import { render } from "./OutletSale.vue?vue&type=template&id=63df0c22"
import script from "./OutletSale.vue?vue&type=script&lang=js"
export * from "./OutletSale.vue?vue&type=script&lang=js"

import "./OutletSale.vue?vue&type=style&index=0&id=63df0c22&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__